import { Link } from 'react-router-dom'
import { Map, Ruler, Building2, ArrowRight } from 'lucide-react'
import AnimatedSection from '@/components/AnimatedSection'

const services = [
  {
    icon: Map,
    title: 'Topographic Survey',
    description:
      'Terrain, elevation, drainage, and existing-feature mapping for design and planning teams.',
  },
  {
    icon: Ruler,
    title: 'Boundary Survey',
    description:
      'Property line identification, monumentation, and documentation for confident land decisions.',
  },
  {
    icon: Building2,
    title: 'Construction Survey',
    description:
      'Setting out, control points, and verification checks that keep construction aligned to design.',
  },
]

export default function ServicesPreview() {
  return (
    <section className="bg-[#f7f4ef] py-24">
      <div className="section-padding mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <AnimatedSection>
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-accent-dark">
              Services
            </span>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-black sm:text-4xl">
              Technical surveying support across the project lifecycle.
            </h2>
            <p className="mt-5 text-sm leading-7 text-neutral-600">
              From due diligence to construction delivery, Advict gives clients
              the measured evidence needed to move forward.
            </p>
            <Link to="/services" className="btn-outline mt-8">
              See All Services
              <ArrowRight className="h-4 w-4" />
            </Link>
          </AnimatedSection>

          <div className="grid gap-px overflow-hidden border border-neutral-200 bg-neutral-200 md:grid-cols-3">
            {services.map((service, index) => (
              <AnimatedSection key={service.title} delay={index * 0.08}>
                <Link
                  to="/services"
                  className="group flex h-full min-h-[310px] flex-col bg-white p-7 transition-colors hover:bg-black"
                >
                  <div className="mb-10 flex h-11 w-11 items-center justify-center border border-neutral-200 text-accent-dark transition-colors group-hover:border-white/25 group-hover:text-accent">
                    <service.icon className="h-5 w-5" />
                  </div>
                  <h3 className="text-xl font-semibold text-black transition-colors group-hover:text-white">
                    {service.title}
                  </h3>
                  <p className="mt-4 text-sm leading-7 text-neutral-600 transition-colors group-hover:text-neutral-300">
                    {service.description}
                  </p>
                  <span className="mt-auto inline-flex items-center gap-2 pt-8 text-sm font-semibold text-accent-dark transition-colors group-hover:text-accent">
                    Details
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
